import { useCustomFunctionalityPermissions } from './use-custom-functionality-permissions';

/** Compatibility API for existing custom-functionality consumers. */
export function useCustomFunctionality(key: string): {
  hasAccess: boolean;
  isPending: boolean;
} {
  const permissions = useCustomFunctionalityPermissions();
  return {
    hasAccess: permissions.has(key),
    isPending: permissions.status === 'loading',
  };
}

export function useHasCustomFunctionality(key: string): boolean {
  return useCustomFunctionality(key).hasAccess;
}
